import { Directive, Input, OnChanges, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appBackgroundProgress]',
  standalone: false,
})
export class BackgroundProgressDirective implements OnChanges, AfterViewInit {
  @Input('appBackgroundProgress') progress?: number | null;

  private showingProgress = false;
  private initialised = false;

  constructor(
    private elementRef: ElementRef<HTMLButtonElement>,
    private renderer: Renderer2,
  ) {}

  ngOnChanges() {
    this.update();
  }

  ngAfterViewInit() {
    this.renderer.addClass(this.elementRef.nativeElement, 'btn-progress');

    this.initialised = true;
    this.update();
  }

  update() {
    if (!this.initialised) {
      return;
    }

    if (this.progress != null) {
      const percent = ((1 - this.progress) * 100).toFixed(1);
      this.renderer.setStyle(this.elementRef.nativeElement, 'background-position', `${percent}% 0`);
    }

    const shouldShowProgress = this.progress != null;
    if (this.showingProgress !== shouldShowProgress) {
      if (shouldShowProgress) {
        this.renderer.addClass(this.elementRef.nativeElement, 'is-progressing');
      } else {
        this.renderer.removeClass(this.elementRef.nativeElement, 'is-progressing');
      }

      this.showingProgress = shouldShowProgress;
    }
  }
}
